import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { API_BASE_URL, API_NOTIFY_URL } from "../Config/Config";
import { Spin } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const Renewals = () => {
  const [Renewals, setRenewals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [days, setDays] = useState(30);

  const columns = [
    {
      title: "Super ID",
      dataIndex: "SuperId",
      sorter: (a, b) => (a?.SuperId || 0) - (b?.SuperId || 0),
    },
    {
      title: "Client",
      dataIndex: "OrgName",
      render: (_, record) => {
        const truncated =
          record?.OrgName?.length > 45
            ? record?.OrgName?.substring(0, 45) + "..."
            : record?.OrgName;
        return <span title={record?.OrgName}>{truncated}</span>;
      },

      sorter: (a, b) => (a?.OrgName || "").localeCompare(b?.OrgName || ""),
    },
    
    {
      title: "Products",
      dataIndex: "ProductName",
      render: (text) => {
        if (!text) return "-";
      
        return (
          <span title={text}>
            {text.length > 15 ? text.substring(0, 15) + "..." : text}
          </span>
        );
      },
      sorter: (a, b) =>
        (a?.ProductName || "").localeCompare(b?.ProductName || ""),
    },
    {
      title: "SubscribedOn",
      dataIndex: "SubscribedOn",
      render: (text) => text ? text : "-",
      sorter: (a, b) =>
        dayjs(a?.SubscribedOn, "DD-MM-YYYY").valueOf() -
        dayjs(b?.SubscribedOn, "DD-MM-YYYY").valueOf(),
    },
    {
      title: "Renewal Date",
      dataIndex: "RenewalDt",
      render: (text) => text ? text : "-",
      sorter: (a, b) =>
        dayjs(a?.RenewalDt, "DD-MM-YYYY").valueOf() -
        dayjs(b?.RenewalDt, "DD-MM-YYYY").valueOf(),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <div className="action-icon d-inline-flex align-items-center">
          <Link
            to="#"
            className="me-2 p-2 d-flex align-items-center border rounded"
            data-bs-toggle="modal"
            data-bs-target="#Notification"
            onClick={() => fetchCompanyDetails(record)}
          >
            <i className="ti ti-bell" />
          </Link>
          {/* <Link
            to="#"
            className="me-2 p-2 d-flex align-items-center border rounded"
            data-bs-toggle="modal"
            data-bs-target="#Notification"
          >
            <i className="ti ti-currency-rupee" />
          </Link> */}
        </div>
      ),
    },
  ];

  const getallorgkeygeneration = async () => {
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/getrenewal?days=${days}`);

      if (!res.ok) {
        throw new Error("Failed to fetch renewals");
      }

      const data = await res.json();

      const rawData = data?.ResultData || [];
      // const upcomingData = rawData.filter( // (item) => item.RenewalType === "Upcoming", // );

      setRenewals(rawData);
    } catch (error) {
      console.error("Error fetching renewals:", error);
    } finally {
      setLoading(false);
    }
  };

  const [NotifytModalData, setNotifyModalData] = useState({
    OrgName: "",
    PrimaryEmailAddr: "",
    PrimaryMobile: "",
    Subject: "",
    Message: "",
  });

  const fetchCompanyDetails = (record) => {
    console.log(record, "record");

    let finalMessage = "";

    // CASE 1: Client Inactive
    if (!record.IsActive) {
      finalMessage = `
        Hi, ${record.OrgName}
    
        We noticed that your Device is currently *inactive*.
        Please contact our support team to reactivate your services 
        and resume normal operations.
    
         Device Details:
        Model: ${record.DeviceModel}
        Serial No: ${record.SerialNo}
        MachineId: ${record.MachineId}
    
        Warm regards,
        PerennialCode Support Team
    
        Contact Us:
        Phone: 8297230010
        Email: support@perennialcode.in
        `;
    }
    // CASE 2: Client Active but Device Offline
    else if (record.IsActive) {
      finalMessage = `
        Hi, ${record.OrgName}
    
        Your device appears to be *offline*, and attendance data 
        has not been received for the past few days.
    
        Please check the following:
        • Power supply to the device
        • Internet/network connection
        • Device wiring and connectivity
    
        Device Details:
        Model: ${record.DeviceModel}
        Serial No: ${record.SerialNo}
        MachineId: ${record.MachineId}
    
        If the issue persists, kindly contact our support team.
    
        Warm regards,
        PerennialCode Support Team
    
        Contact Us:
        Phone: 8297230010
        Email: support@perennialcode.in
        `;
    }

    setNotifyModalData({
      OrgName: record.OrgName || "",
      PrimaryEmailAddr: record.PrimaryEmailAddr || "",
      PrimaryMobile: record.PrimaryMobile || "",
      Subject: "Important Notification From Our Team",
      Message: finalMessage,
    });
  };

  const sendWhatsAppNotification = async () => {
    if (!NotifytModalData.PrimaryMobile || !NotifytModalData.Message) {
      alert("Contact number and message are required!");
      return;
    }

    try {
      const payload = {
        number: NotifytModalData.PrimaryMobile,
        client: NotifytModalData.OrgName,
        subject: NotifytModalData.Subject,
        message: NotifytModalData.Message,
      };

      console.log("Sending JSON:", payload); // Debugging

      const res = await axios.post(
        `${API_NOTIFY_URL}pcode/sendWhatsAppmessageHealthcheck`,
        payload,
      );

      if (res.data.success) {
        alert("WhatsApp message sent successfully!");
      } else {
        alert("Failed to send message!");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };

  const handleChange1 = (e) => {
    setNotifyModalData({
      ...NotifytModalData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (days && days > 0) {
      getallorgkeygeneration();
    }
  }, [days]);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Renewals</h4>
                <h6>Manage your Upcoming Renewals</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {/* <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Refresh"
                >
                  <i data-feather="rotate-ccw" className="feather-rotate-ccw" />
                </Link>
              </li> */}
               <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
              </ul>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <div className="search-set py-3"></div>

              <div className="d-flex align-items-center gap-2">
                <label className="mb-0 fw-semibold">Days</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="0"
                  style={{ width: "80px", height: "30px" }}
                  value={days}
                  onChange={(e) => setDays(e.target.value)}
                />
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table
                      columns={columns}
                      dataSource={Renewals}
                    
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      <div className="modal fade" id="Notification">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="text-gray-9 fw-medium">
                Send Notification To Client
              </h3>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className=" fw-medium">Client</label>
                    <input
                      type="text"
                      className="form-control"
                      name="OrgName"
                      value={NotifytModalData.OrgName}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className=" fw-medium">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Subject"
                      value={NotifytModalData.Subject}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="fw-medium">Email To</label>
                    <input
                      type="email"
                      className="form-control"
                      name="PrimaryEmailAddr"
                      value={NotifytModalData.PrimaryEmailAddr}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="fw-medium">Contact</label>
                    <input
                      type="text"
                      className="form-control"
                      name="PrimaryMobile"
                      value={NotifytModalData.PrimaryMobile}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="fw-medium">Notify Message Content</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      name="Message"
                      value={NotifytModalData.Message}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="text-center">
                  <button
                    className="btn btn-success text-white"
                    onClick={sendWhatsAppNotification}
                  >
                    Notify
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Renewals;
